module.exports = __webpack_public_path__ + "static/image/logo-family/logo_store@3x.png?97359483";